export const apiEndpoints = {
  applicationAdmin: '/applicationadmin',
  databaseAdmin: '/databaseadmin',
  appUsers: '/appuser',
  metricApis: '/metric',
  calcEngineApis: '/calcengine',
  dynamicTable: '/dynamictable',
  userBoard: '/userboard',
  userTable: '/usertable',
  filter: '/filter',
  filterBar: '/filter-bar',
  contact: '/contact',
  customView: '/customview',
  pdfGeneration: '/pdf',
  integration: '/integration',
  userSecurity: '/usersecurity',
  auditLog: '/auditlog',
  quickBooks: '/quickbooks',
}
